<template>
  <div
    v-if="!loading">
    <tabs
      :links="customFieldsLinks"
      :mode="'emitter'"
      :current-tab="tab"
      @changeView="tab = $event"
      class="is-border-bottom">
    </tabs>
    <div>
      <div class="columns is-gapless is-vcentered is-border-bottom has-background-light is-minH50p is-marginless">
        <div class="column is-padding-left">
          <span
            v-if="customFields && customFields.length"
            class="is-size-6">{{ customFieldsLinks.find(x => x.link === tab).label }} ({{ customFields.filter(x => tab === 'all' ? customFields.length : x.model_type === tab).length }})</span>
        </div>
        <div class="column is-narrow is-border-left is-self-stretched">
          <router-link
            :to="{name: 'CustomFieldForm'}"
            class="button is-radiusless is-small is-primary is-minH100">
            <span class="has-text-weight-medium">Créer un nouveau champ</span>
          </router-link>
        </div>
      </div>

      <div class="table is-fullwidth is-marginless has-cells-vcentered">
        <div>
          <div class="columns row-width-actions-bar is-gapless is-border-bottom">
            <div class="column is-1 is-padding-xsmall"></div>
            <div class="column is-3 is-padding-xsmall">
              Nom
            </div>
            <div class="column is-3 is-padding-xsmall">
              Type
            </div>
            <!-- <th>Obligatoire</th> -->
            <div class="column is-3 is-padding-xsmall">
              Filtrable
            </div>
            <div class="column is-2 is-padding-xsmall"></div>
          </div>
        </div>
        <div
          v-if="customFields && customFields.length"
          class="is-size-6"
          v-dragula="customFields"
          drake="one">
          <div
            v-for="customField in customFields.filter(x => tab === 'all' ? x : x.model_type === tab)"
            :key="customField.pk"
            class="columns draggable is-relative is-zindex-2 is-marginless isHeight50p is-border-bottom">
            <div
              :class="{ 'has-cursor-grab' : tab !== 'all' }"
              class="column is-1 is-padding-xsmall center-content">
              <span
                v-if="tab !== 'all'"
                class="icon"><i class="fas fa-grip-lines"></i></span>
            </div>
            <router-link
              :to="{ name: 'CustomFieldForm', params: { customFieldPk: customField.pk }}"
              class="column is-3 is-cell-hoverable is-padding-xsmall center-content-left">
              <span>{{ customField.title }}</span>
            </router-link>
            <div class="column is-3 is-padding-xsmall center-content-left">
              <span>{{ customField.input_type | customFieldsLabel }}</span>
            </div>
            <!-- <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
              <span>{{ customField.input_config.mandatory ? 'Oui' : 'Non' }}</span>
            </div> -->
            <div class="column is-3 is-padding-xsmall center-content-left">
              <span>{{ customField.input_config.filterable ? 'Oui' : 'Non' }}</span>
            </div>
            <div class="column is-2 is-padding-xsmall center-content-right">
              <display-button-list
                :buttons="buttonList"
                :data="customField">
              </display-button-list>
            </div>
          </div>
        </div>
      </div>
    </div>
    <submit-sticky-buttons
      v-if="tab !== 'all'"
      @submit="submit"
      :loading="loading"
      button-id="customFieldForm"></submit-sticky-buttons>
  </div>
</template>

<script>
import DefaultValues from '@/mixins/DefaultValues'
import { CustomFields } from '@/mixins'
export default {
  name: 'CustomFields',
  components: {
  },
  mixins: [DefaultValues, CustomFields],
  data () {
    return {
      tab: 'all',
      customFieldsLinks: [
        {
          label: 'Tous',
          link: 'all'
        },
        {
          label: 'Contact',
          link: 'contact'
        }
        // {
        //   label: 'Programme',
        //   link: 'program'
        // },
        // {
        //   label: 'Adv',
        //   link: 'adv'
        // }
      ],
      customFields: null,
      loading: false,
      buttonList: [
        {
          action: (id) => {
            this.$router.push({ name: 'CustomFieldForm', params: { customFieldPk: id } })
          },
          icon: 'fa-user-edit',
          text: 'Modifier le champ'
        },
        {
          action: async (id) => {
            await this.deleteCustomField(id)
            this.init()
          },
          icon: 'fa-trash-alt',
          text: 'Supprimer le champ'
        }
      ]
    }
  },
  computed: {
    filteredCustomFields () {
      return this.customFields.filter(x => this.tab === 'all' ? x : x.model_type === this.tab)
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      this.loading = true
      this.customFields = await this.getCustomFields()
      this.loading = false
    },
    async submit () {
      const customFieldsPromise = this.filteredCustomFields.map(async (customField, i) => {
        const val = {
          ...customField.input_config,
          display_order: i
        }
        await this.patchCustomField(customField.pk, { input_config: val })
      })
      await Promise.all(customFieldsPromise)
    }
  }
}
</script>

<style lang="sass">
.isHeight50p
  height: 45px
.center-content
  white-space: nowrap
  display: flex
  justify-content: center
  align-items: center
  height: 100%
.center-content-right
  white-space: nowrap
  display: flex
  align-items: center
  height: 100%
.center-content-right
  white-space: nowrap
  display: flex
  flex-direction: row-reverse
  align-items: center
  height: 100%
</style>
